import React, { useEffect, useMemo, useState } from 'react';
import { API_BASE_URL } from '../config';

export default function BlockchainArchive() {
  const [minted, setMinted] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancel = false;
    async function load() {
      setLoading(true);
      setError('');
      try {
        const [mRes, cRes] = await Promise.all([
          fetch(`${API_BASE_URL}/api/archive/minted?limit=12`),
          fetch(`${API_BASE_URL}/api/feed/scene-ranks?window=7d&posted=any&limit=20`),
        ]);
        const mj = (await mRes.json()) || {};
        const cj = (await cRes.json()) || {};
        if (!cancel) {
          setMinted(Array.isArray(mj.items) ? mj.items : []);
          setCandidates(Array.isArray(cj.scenes) ? cj.scenes : []);
        }
      } catch (e) {
        if (!cancel) setError('Failed to load archive data.');
      } finally {
        if (!cancel) setLoading(false);
      }
    }
    load();
    return () => { cancel = true; };
  }, []);

  const mintedList = useMemo(() => minted.map(m => (
    <div key={m.mint_id} className="ba-card">
      <div className="ba-title">Mint #{m.mint_id}</div>
      <div className="ba-sub">Scene: {m.scene_id}</div>
      <div className="ba-sub">Minted: {m.minted_at}</div>
      {typeof m.score === 'number' && <div className="ba-score">Score: {m.score.toFixed(1)}</div>}
      {m.viewer_url && (
        <div className="ba-link"><a href={m.viewer_url} target="_blank" rel="noreferrer">View snapshot</a></div>
      )}
    </div>
  )), [minted]);

  const candidateList = useMemo(() => candidates.map((s, idx) => (
    <div key={`${s.scene_id}-${idx}`} className="ba-card">
      <div className="ba-title">Candidate</div>
      <div className="ba-sub">Scene: {s.scene_id}</div>
      <div className="ba-sub">Started: {s.started_at}</div>
      <div className="ba-sub">Posted: {s.posted ? 'Yes' : 'No'}</div>
      <div className="ba-score">Score: {Number(s.score).toFixed(1)}</div>
    </div>
  )), [candidates]);

  return (
    <div style={{padding: '16px'}}>
      <h2>Blockchain Archive</h2>
      <p>Recent minted scenes and current high‑value candidates (7‑day window).</p>
      {loading && <div>Loading…</div>}
      {error && <div style={{color:'#b00'}}>{error}</div>}

      <h3>Recent mints</h3>
      <div className="ba-grid">
        {mintedList.length ? mintedList : <div>No mints yet.</div>}
      </div>

      <h3 style={{marginTop:'24px'}}>Top candidates (7d)</h3>
      <div className="ba-grid">
        {candidateList.length ? candidateList : <div>No candidates found.</div>}
      </div>

      <style>{`
        .ba-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; }
        .ba-card { border: 1px solid #333; border-radius: 8px; padding: 12px; background: #0b0b0b; }
        .ba-title { font-weight: 600; margin-bottom: 4px; }
        .ba-sub { color: #aaa; font-size: 0.9rem; }
        .ba-score { margin-top: 6px; font-weight: 600; }
        .ba-link a { color: #88c; }
        @media (max-width: 1024px) { .ba-grid { grid-template-columns: repeat(2, 1fr); } }
        @media (max-width: 768px) { .ba-grid { grid-template-columns: 1fr; } }
      `}</style>
    </div>
  );
}


